import { Chart, registerables } from "chart.js";

let registered = false;

export function ensureChartJs() {
  if (!registered) {
    Chart.register(...registerables);
    registered = true;
  }
}

export { Chart };
